export const GET_APPROVALS_DEFAULT = "GET_APPROVALS_DEFAULT";
export const GET_APPROVALS_STARTED = "GET_APPROVALS_STARTED";
export const GET_APPROVALS_SUCCEEDED = "GET_APPROVALS_SUCCEEDED";
export const GET_APPROVALS_FAILED = "GET_APPROVALS_FAILED";
export const GET_APPROVALS_LOADING = "GET_APPROVALS_LOADING";
export const APPROVE_TRANSACTIONS_STARTED = "APPROVE_TRANSACTIONS_STARTED";
export const APPROVE_TRANSACTIONS_SUCCEEDED = "APPROVE_TRANSACTIONS_SUCCEEDED";
export const APPROVE_TRANSACTIONS_FAILED = "APPROVE_TRANSACTIONS_FAILED";
export const APPROVE_TRANSACTIONS_LOADING = "APPROVE_TRANSACTIONS_LOADING";

export const LOAD_MORE_APPROVALS_STARTED = "LOAD_MORE_APPROVALS_STARTED";
export const LOAD_MORE_APPROVALS_SUCCEEDED ="LOAD_MORE_APPROVALS_SUCCEEDED";
export const LOAD_MORE_APPROVALS_FAILED = "LOAD_MORE_APPROVALS_FAILED";
export const NO_MORE_APPROVALS = "NO_MORE_APPROVALS";